import { render, staticRenderFns } from "./mailObserver.vue?vue&type=template&id=584060bb"
import script from "./mailObserver.vue?vue&type=script&lang=js"
export * from "./mailObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584060bb')) {
      api.createRecord('584060bb', component.options)
    } else {
      api.reload('584060bb', component.options)
    }
    module.hot.accept("./mailObserver.vue?vue&type=template&id=584060bb", function () {
      api.rerender('584060bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/mailObserver.vue"
export default component.exports